module.exports = __webpack_public_path__ + "assets/druid.09b411e5.svg";